import _typeof from "@babel/runtime/helpers/typeof";
var gql = null;
try {
  gql = require('@apollo/client').gql;
} catch (er) {}
export var MYKBB_MENU_ID = 'mykbbToggle';
export var GLOBALNAV_KBB_STAGING_URL = 'https://staging.kbb.com';
export var GLOBALNAV_KBB_BASE_URL = process.env.NODE_ENV === 'production' ? '' : GLOBALNAV_KBB_STAGING_URL;
export var isMobile = (typeof window === "undefined" ? "undefined" : _typeof(window)) === 'object' ? 'ontouchstart' in window : false;